import React, { useEffect, useState } from "react";
import {

    CModal,
    CModalBody,
} from "@coreui/react";
import crossButton from "../../../src/components/assets/image/crossButton.svg";
// import { imageBaseUrls } from "../../constant/ApiUrls";

const CarAddFeature = ({
    buttonLabel = "Add Feature",
    editMode = false,
    memberData = {},
    handleAddFeature
}) => {

    const [isModalVisible, setIsModalVisible] = useState(false); // Local State

    const [categoryName, setCategoryName] = useState("");
    const [description, setDescription] = useState("");
    const [link, setLink] = useState("");
    const [linkName, setLinkName] = useState("");



    useEffect(() => {
        if (editMode && memberData) {
            setCategoryName(memberData.title || "");
            setDescription(memberData.description || "");
            setLink(memberData.link || "");
            setLinkName(memberData.link_title || "");
            // console.log('hjdhchjud',imageBaseUrls + memberData.image);
            // setImage(imageBaseUrls + memberData.image);
        }
    }, [editMode, memberData]);

    const resetForm = () => {
        setCategoryName("");
        setDescription("");
        setLink("");
        setLinkName("");
        // setImage(null);
        // setUploadImage(null);
    };


    // // Handle Image Upload
    // const handleImageChange = (event) => {
    //     const file = event.target.files[0];
    //     if (file) {
    //         const validTypes = ["image/jpeg", "image/png", "image/jpg"];
    //         if (validTypes.includes(file.type)) {
    //             const imageUrl = URL.createObjectURL(file);
    //             setImage(imageUrl);
    //             setUploadImage(file);
    //         } else {
    //             alert("Please select a valid image file (JPEG, PNG, JPG)");
    //         }
    //     }
    // };


    const handleSubmit = () => {
        if (categoryName.trim() === "") {
            alert("Feature title is required");
            return;
        }


        if (description.trim() === "") {
            alert("Feature description is required");
            return;
        }
        if (linkName.trim() === "") {
            alert("Please Enter Valid Link Title");
            return;
        }
        if (link.trim() === "") {
            alert("Please Enter Valid Link");
            return;
        }

  


        const data = {
            title: categoryName,
            description: description,
            link:link,
            link_title:linkName,
            id: editMode ? memberData.id : undefined,
        };

        handleAddFeature(data); // 🔁 Pass data to parent
        setIsModalVisible(false);
        resetForm();
    };





    return (
        <div>
            {/* Button to Open Modal */}
            <button
                onClick={() => {
                    if (!editMode) {
                        resetForm(); // Reset the form if adding
                    }
                    setIsModalVisible(true)
                }}
                style={{
                    backgroundColor: editMode === true ? "#1b87f4" : "rgb(0 0 0)",
                    color: "white",
                    border: "none",
                    cursor: "pointer",
                    borderRadius: "4px",
                    fontSize: editMode === true ? "10px" : "14px",
                    minWidth: "60px",
                    // width: "100%",
                    height: editMode === true ? "24px" : "30px",  // Increased height
                    padding: editMode === true ? "4px 10px" : "4px 10px", // Added padding
                    display: "flex",
                    alignItems: "center",
                    // alignSelf:"end",
                    justifyContent: "center",
                }}
            >{buttonLabel}</button>

            <CModal
                alignment="center"
                visible={isModalVisible}
                onClose={() => setIsModalVisible(false)}
                className="attributemodal"

            >
                <CModalBody className="main-container createAdmin" >
                    <div className="main-container createAdmin">
                        {/* Close Button */}
                        <div className="cross-btn-div d-flex">
                            <img
                                onClick={() => setIsModalVisible(false)}
                                src={crossButton}
                                alt="close"
                                className="cross-button"
                            />
                        </div>

                        <form onSubmit={(e) => e.preventDefault()} className="login-form">
                            <div className="mb-4">
                                <h4
                                    className="h4 fw-bold"
                                    style={{ color: "#007bff", textAlign: "center" }}
                                >
                                    <b>{editMode === true ? "Edit Feature" : "Add New Feature"}</b>
                                </h4>
                            </div>

                            {/* Image Upload Section */}
                            {/* <div className="mb-3 input-login-box">
                                <div className="form-row d-flex justify-content-center mt-2">
                                    <input
                                        type="file"
                                        accept="image/*"
                                        id="categoryImageUpload"
                                        style={{ display: "none" }}
                                        onChange={handleImageChange}
                                    />
                                    <img
                                        style={{ height: "120px", width: "120px", borderRadius: "10px", objectFit: "cover" }}
                                        onClick={() =>
                                            document.getElementById("categoryImageUpload").click()
                                        }
                                        src={image || placeholderImage}
                                        F alt="Feature Preview"

                                    />
                                </div>
                            </div> */}


                            {/* Category Name Input */}
                            <div className="mb-3 input-login-box">
                                <input
                                    value={categoryName}
                                    onChange={(e) => setCategoryName(e.target.value)}
                                    name="name"
                                    type="text"
                                    className="form-control login-input"
                                    placeholder="Enter feature title"
                                />
                            </div>

                            {/* Description Input */}
                            <div className="mb-3 input-login-box">
                                <textarea
                                    value={description}
                                    onChange={(e) => setDescription(e.target.value)}
                                    name="description"
                                    className="form-control login-input"
                                    placeholder="Enter feature description"
                                    rows="5"
                                    style={{ height: 'auto', minHeight: '100px' }} // force override
                                />

                            </div>

                            <div className="mb-3 input-login-box">
                                <input
                                    value={linkName}
                                    onChange={(e) => setLinkName(e.target.value)}
                                    name="link_title"
                                    type="text"
                                    className="form-control login-input"
                                    placeholder="Enter link title"
                                />
                            </div>
                            <div className="mb-3 input-login-box">
                                <input
                                    value={link}
                                    onChange={(e) => setLink(e.target.value)}
                                    name="link"
                                    type="text"
                                    className="form-control login-input"
                                    placeholder="Enter feature link"
                                />
                            </div>



                            {/* Submit Button */}
                            <button
                                className="w-100 btn btn-md btn-warning fw-bold text-light button-color"
                                type="button"
                                onClick={handleSubmit}
                            >
                                {editMode ? "Update" : "Submit"}
                            </button>
                        </form>
                    </div>
                </CModalBody>
            </CModal>
        </div>
    );
};

export default CarAddFeature;
